import { PHISHING_USER_STATUS } from '../../domain/domainCodes.js'
/**
 * English mirror of ./strings.ar.js — GENERATED by scripts/i18n/build.mjs.
 *
 * Wording follows the legacy Locale/*.resx English resources wherever the
 * legacy screen had the same label. To change any of it, edit
 * scripts/i18n/strings.en.json and re-run the script.
 */

const shared = {
  editor: 'Editor',
  addNew: 'Add New',
  export: 'Download',
  import: 'Import',
  close: 'Close',
  active: 'Active',
  inactive: 'Disabled',
  edit: 'Update',
  delete: 'Delete',
}

export const templatesStrings = {
  qrHint: 'A unique code is generated for each recipient when sent. Keep {{TrackingQr}} in the email content.',
  qrPreviewFailed: 'The QR preview could not be loaded. Check the QR block in the email content and try again.',
  actionFailed: 'The operation could not be completed',
  imported: 'Templates imported',
  importNote: 'The archive is what this screen exports: one folder per template, each holding details.json. A template whose name already exists is not imported.',
  ...shared,
  title: 'Phishing Templates',

  columns: {
    name: 'Name',
    language: 'Language',

    difficulty: 'Level',
    payloadType: 'Content',
    status: 'Active',

    emailImage: 'The email',
    landingImage: 'Landing Page',
    afterImage: 'After the catch',
  },

  templateImages: 'Template Images',

  surfaces: {
    email: 'Email Thumbnail',
    landing: 'Landing Page Thumbnail',
    after: 'After Phishing Page Thumbnail',
  },

  surfaceTabs: { email: 'The email', landing: 'Landing Page', after: 'After the catch' },

  surfaceNote: 'Preview drawn from the template\'s own data; the uploaded image replaces it once saved.',

  languages: {
    ar: 'AR',
    en: 'EN',
    arFull: 'Arabic Text',
    enFull: 'English Text',
  },

  form: {
    title: 'Phishing template',
    category: 'Category',

    categoryPlaceholder: 'Choose a category',
    save: 'Save',
    saved: 'Template saved',
    required: 'Field required',

    steps: {
      identity: 'Template details',
      email: 'The email',
      landing: 'Landing Page',
      after: 'After the catch',
    },
    stepHints: {
      identity: 'Category, name, level and language',
      email: 'Subject, content and attachments',
      landing: 'Where a click on the link lands',
      after: 'What they see once they are caught',
    },

    subject: 'Subject',
    thumbnail: 'Content Thumbnail',
    body: 'Body',
    richText: 'Rich Text',
    attachments: 'Upload Email Attachments',
    trackingImage: 'Tracking Image',
    landingPage: 'Landing Page',
    captureData: 'Capture Submitted Data',
    capturePasswords: 'Capture Passwords',
    redirectToUrl: 'Redirect To Url',
    redirectUrl: 'Redirect Url',
    redirectPage: 'Post-Caught Content',
    isActive: 'Active',
  },

  difficulties: { 0: 'Easy', 1: 'Medium', 2: 'Hard' },

  payloads: { 0: 'Website', 1: 'Attachment', 2: 'Information Request', 3: 'QR code' },

  content: {
    title: 'Template content',
    subject: 'Message Title',
    tabs: { compose: 'Compose', source: 'HTML', preview: 'Preview' },
    tokens: 'Merge fields',
    tokenHint: 'These fields are replaced with the recipient\'s details on send.',
    bold: 'Bold',
    italic: 'Italic',
    underline: 'Underline',
    heading: 'Heading',
    bullets: 'List',
    link: 'Link',
    linkPrompt: 'URL',
    clear: 'Clear formatting',
    save: 'Save',
    saved: 'Operation Completed Successfully',
  },

  tokenList: [
    { token: '{{name}}', label: 'Recipient name' },
    { token: '{{email}}', label: 'Email' },
    { token: '{{department}}', label: 'Group' },
    { token: '{{link}}', label: 'Campaign link' },
    { token: '{{date}}', label: 'Date' },
  ],

  deleteConfirm: 'Delete this template?',
  deleted: 'Template deleted',

}

export const campaignsStrings = {
  ...shared,
  title: 'Phishing Campaigns',
  importTitle: 'Import old phishing system data',
  importHint: 'Upload .db File',
  from: 'From',
  to: 'To',
  report: 'Report',
  refresh: 'Refresh',

  exportPdf: 'Export PDF',
  exporting: 'Exporting…',
  exported: 'Campaign list exported',
  exportFailed: 'The campaign list could not be exported',
  exportNothing: 'There are no campaigns to export',
  exportGeneratedOn: 'Generated on',
  exportSearch: 'Search',
  exportFunnel: 'From sent to data submitted',
  exportByCampaign: 'Results by campaign',
  exportNoActivity: 'These campaigns have recorded no results yet, so there is nothing to chart.',
  exportEmpty: 'No campaigns',

  saved: 'Campaign saved',
  completed: {
    draft: 'Campaign draft saved',
    schedule: 'Campaign scheduled. It will start automatically at the selected time.',
    activate: 'Campaign launched. Delivery preparation has started.',
  },

  // See the note in strings.ar.js: each message names what was being written or read.
  settingsFail: {
    page: 'Could not load the phishing settings',
    engine: 'Could not save the phishing engine settings',
    headers: 'Could not save the ignored mail headers',
  },
  engineSaved: 'Phishing engine settings saved',
  headersSaved: 'Ignored mail headers saved',

  templatesFail: {
    list: 'Could not load the phishing templates',
    load: 'Could not load this template',
    save: 'Could not save the template',
    delete: 'Could not delete the template',
    import: 'Could not import the templates file',
    export: 'Could not export the templates',
  },

  copied: 'Campaign copied',
  deleted: 'Campaign deleted',
  activated: 'Campaign activated',
  disabled: 'Campaign disabled',

  // See the note in strings.ar.js: each failure names the operation that failed.
  fail: {
    page: 'Could not load the campaigns page',
    list: 'Could not load the campaigns',
    summary: 'Could not load the campaign summary for this period',
    save: 'Could not save the campaign',
    copy: 'Could not copy the campaign',
    delete: 'Could not delete the campaign',
    activate: 'Could not activate the campaign',
    disable: 'Could not disable the campaign',
  },
  cloneTitle: 'Clone campaign',
  cloneHint: 'Creates a new campaign from these settings. Review its audience and timing before launch.',
  review: {
    title: 'Review campaign',
    action: 'Review audience',
    edit: 'Edit campaign',
    draft: 'Save draft',
    schedule: 'Schedule campaign',
    activate: 'Launch campaign',
    intent: {
      draft: 'This keeps the campaign disabled. No messages will be queued.',
      schedule: 'This campaign will start automatically at the selected time.',
      activate: 'This campaign is due now. Message preparation can begin immediately.',
    },
    audienceTitle: 'Audience',
    enrollment: '{existing} recipients already count toward this license. Confirming will add {new} users. Seats available before confirmation: {remaining}. No login is required.',
    capacity: 'This campaign needs {needed} new seats, but only {remaining} remain. Reduce the audience or increase the license capacity.',
    unlimited: 'Unlimited',
    contentTitle: 'Message and destination',
    timingTitle: 'Delivery timing',
    previewTemplate: 'Preview message',
    confirmTitle: 'Final launch check',
    confirm: {
      schedule: 'I reviewed the message, destination, dates, and unique recipient count.',
      activate: 'I reviewed the message, destination, and unique recipient count. I am ready to launch.',
    },
    confirmRequired: 'Complete the final launch check before continuing.',
    groupCount: 'Selected departments',
    recipientCount: 'Unique eligible recipients',
    audienceEstimate: 'Audience is checked again when the campaign starts. Changes to departments or eligibility can change this count.',
    overlap: 'People in multiple selected departments are listed under one department and counted once.',
    noLicense: 'No active company license is available.',
    empty: 'No eligible recipients. Review the selected departments.',
    previewFailed: 'Could not calculate the audience. Try again.',
    endBeforeStart: 'The end must be after the start.',
    invalidEndDate: 'The campaign end must still be in the future.',
    invalidSendBy: 'Sending must finish after the start, before the end, and in the future.',
    countdown: 'Starts in',
    waiting: 'Starting campaign…',
    daySymbol: 'd',
    hourSymbol: 'h',
    sendWindow: 'Messages go out evenly across the chosen period; when they actually arrive depends on the mail server.',
  },
  actionFailed: 'The operation could not be completed',

  /** No status is stored — these four are derived from active / started / finished. */
  states: {
    scheduled: 'Scheduled',
    running: 'Running',
    finished: 'Finished',
    inactive: 'Disabled',
  },

  disableTitle: 'Stop this campaign?',
  activateTitle: 'Start this campaign?',
  disableConfirm: 'It will stop sending, and its results will no longer be counted.',
  activateConfirm: 'It will run again on its own dates.',
  deleteWarning: 'Its recipient list and every recorded result go with it. This cannot be undone.',

  columns: {
    name: 'Name',
    period: 'Period',
    sent: 'Email Sent',
    opened: 'Email Opened',
    clicked: 'Link Clicked',
    submitted: 'Data Submitted',
    reported: 'Reported',
    status: 'Status',
  },

  row: {
    report: 'Phishing Report',
    notifications: 'Notifications',
    copy: 'Clone',
    activate: 'Activate',
    disable: 'Disable',
  },

  form: {
    message: 'Message and destination',
    timing: 'Timing',
    audience: 'Audience',
    templatePlaceholder: 'Choose a template',
    urlPlaceholder: 'Choose a link',
    senderPlaceholder: 'Choose a sender address',
    programPlaceholder: 'No automatic enrolment',
    name: 'Name',
    template: 'Campaign Template',
    url: 'URL',
    sender: 'Sender Email',
    startDate: 'Start Date',
    endDate: 'End Date',
    schedule: 'Sending schedule',
    groups: 'Departments',
    selectAll: 'Select All',
    filter: 'Filter',
    program: 'Auto-enroll in a learning program',
    active: 'Active',
    save: 'Save',
    required: 'Field required',
    previewTemplate: 'Preview Template',
    schedulingHint: 'The campaign\'s messages are spread evenly across the chosen period, starting the moment the campaign begins.',
    /* See the note on the Arabic list: the field decides a DURATION, and the drawer
       turns it into the absolute `SendEmailsBy` the API stores. */
    sendWindows: [
      { value: '0', label: 'Send to everyone when the campaign starts' },
      { value: '15', label: 'Send to everyone within the first 15 minutes' },
      { value: '30', label: 'Send to everyone within the first 30 minutes' },
      { value: '60', label: 'Send to everyone within the first hour' },
      { value: '120', label: 'Send to everyone within the first two hours' },
      { value: '180', label: 'Send to everyone within the first 3 hours' },
    ],
    windowTooLong: 'The chosen period runs past the campaign end. Pick a shorter one, or move the end date.',
    sendWindowKept: 'Saved time',
    uniqueName: 'Choose a different name for the new campaign.',
  },

  deleteConfirm: 'Delete this campaign?',
}

export const phishingSettingsStrings = {
  ...shared,
  title: 'Settings',
  subtitle: 'Phishing',

  actionFailed: 'The operation could not be completed',
  saved: 'Saved',
  save: 'Save',
  required: 'Required',

  /** The settings tab — the loose settings the legacy keeps under phishing settings. */
  settings: {
    panelTitle: 'Phishing Settings',
    panelSubtitle: 'Manage campaign automation, report listener, simulation URLs, and Outlook reporting add-in',
    panelInfo: 'Central controls for the simulated phishing platform: configure backend worker schedules, fallback link delivery, and the user reporting add-in.',

    servicesGroup: 'Background Automation Services',
    servicesGroupHint: 'Continuous background workers running in Rawam Jobs that execute campaigns and ingest employee reports',
    deliveryGroup: 'Simulation Delivery & Detection Protection',
    deliveryGroupHint: 'Phishing domain fallback authority and automated scanner filtering',
    reportingGroup: 'User Reporting & Outlook Integration',
    reportingGroupHint: 'Reporting behavior, SOC mailbox dispatch, and Outlook Add-in configuration',

    statusActive: 'Active',
    statusDisabled: 'Disabled',

    engine: 'Phishing engine',
    engineHint: 'Sends phishing campaigns and records what recipients do',
    engineInfo: 'The background worker in Rawam Jobs responsible for starting scheduled phishing campaigns, dispatching simulated emails via SMTP in batches, and automatically assigning remedial training programs upon campaign completion.',
    intervalHint: 'As hours:minutes:seconds — for example 00:00:10',
    phishingEnabled: 'Activate phishing feature',
    phishingEnabledInfo: 'When enabled, the background engine actively processes and dispatches phishing campaigns for this tenant. Disabling this immediately halts all outgoing simulation emails and campaign execution.',
    phishingInterval: 'Phishing service interval',
    delayBeforeNextRun: 'Delay before next run',
    phishingIntervalInfo: 'How frequently the background worker checks for campaigns ready to start, sends email batches (50 per batch), and marks expired campaigns as finished. Format: hh:mm:ss.',

    listener: 'Report mailbox listener',
    listenerHint: 'Reads the mailbox users report suspicious messages to',
    listenerInfo: 'The background listener in Rawam Jobs that connects to your configured IMAP reporting mailbox, detects employee-reported phishing emails, extracts simulation security tokens, updates campaign metrics, and automatically awards gamification points.',
    listenerEnabled: 'Activate email listener feature',
    listenerEnabledInfo: 'When enabled, the service regularly connects to the active IMAP profile to process user reports. Disabling this stops IMAP mailbox polling and report ingestion for this tenant.',
    listenerInterval: 'Email Listener Service Interval',
    listenerIntervalInfo: 'How frequently the listener connects to the IMAP mailbox to fetch and process newly reported messages. Format: hh:mm:ss.',

    url: 'Api Url',
    urlHint: 'The address phishing pages are served from and events are counted against',
    urlInfo: 'The default fallback server URL used to generate simulated phishing links ({{TrackingUrl}} and __URL) and tracking pixels when a campaign does not have a dedicated domain selected from the Domains tab.',
    urlFieldInfo: 'Root address for phishing simulation landing pages and event tracking. Affects campaigns that do not have a specific custom domain selected.',

    skipHeaders: 'Skip or include user requests with the following details',
    skipHeadersHint: 'Rules match a header name and its exact value. Exclude rules prevent counting the request. If include rules exist, the request must match at least one. Exclusions take priority.',
    skipHeadersInfo: 'Protects your campaign metrics from security scanners, AV web crawlers, and Microsoft Defender sandboxes by ignoring HTTP requests matching these header rules so they are not counted as employee clicks.',
    skipHeadersAdd: 'Add New',
    skipHeadersEmpty: 'No ignored headers',
    headerName: 'Key',
    headerNameInfo: 'HTTP header name to inspect, such as User-Agent or X-Scanner-Scan-Id.',
    headerValue: 'Value',
    headerValueInfo: 'The exact header string value to compare against incoming requests.',
    headerType: 'Type',
    headerTypeInfo: 'Exclude: Drop and ignore requests with this header from analytics. Include: Only count requests matching at least one include rule.',
    headerExclude: 'Skip Request',
    headerInclude: 'Include Request',
    headerNameInvalid: 'Enter a valid header name without spaces, such as User-Agent.',
    headerValueInvalid: 'Header values cannot contain line breaks or null characters.',
    headerDuplicate: 'This rule already exists.',
    headersInvalid: 'The saved header rules could not be read. Correct the header setting before editing it here.',

    outlook: 'Outlook add-in',
    outlookHint: 'How a user reports a suspicious message from inside Outlook',
    outlookInfo: 'Settings distributed to the Rawam Outlook Reporting Add-in to instruct it how to submit reports, where to forward suspicious .eml copies, and how to manage the message in the user mailbox.',
    outlookType: 'Outlook Plugin Reporting Method',
    outlookTypeInfo: 'Choose "Send Email" for the desktop VSTO COM add-in that forwards messages by mail, or "Web API" for the modern Office 365 cross-platform add-in that posts reports directly to Rawam.',
    outlookTypeEmail: 'Send Email (VSTO / Desktop)',
    outlookTypeWebApi: 'Web API (Modern Web Add-in)',
    outlookMethod: 'Reporting method',
    outlookMethodInfo: 'Reports are saved in RAWAM. When a reporting mailbox is configured, the server queues a copy of the original email for delivery to that mailbox. This applies to web and VSTO plugins.',
    outlookMethodBoth: 'Both (Security Ticket & Email Forward)',
    outlookMethodTicket: 'Save in RAWAM and forward from the server',
    outlookMethodEmail: 'Email only (Forward to SOC Mailbox)',
    outlookEmail: 'Reports mailbox',
    outlookEmailInfo: 'Optional incident mailbox. RAWAM forwards using notification SMTP, so notification Jobs must be running. Leave blank to save reports only. Training messages are labelled [TRAINING PHISH]; other reports are labelled [POTENTIAL PHISH].',
    outlookDelete: 'Delete the message after reporting',
    outlookDeleteInfo: 'When enabled, the Outlook add-in moves the reported email from the user inbox directly to Deleted Items as soon as the report is sent.',
    outlookDeleteYes: 'Yes',
    outlookDeleteNo: 'No',
    outlookNote: 'Once set, the reporting method and delete-after-report cannot be left empty; they can be changed to another value.',

    outlookStudioTitle: 'Outlook Add-in Deployment Studio',
    outlookStudioSubtitle: '1-click deployment artifacts and step-by-step installation guides for Microsoft 365, Exchange On-Premises, and Classic Desktop (VSTO / GPO).',
    outlookStudioInfo: 'Deploy the official Rawam Phishing Reporter Add-in across your organization. Choose your mail infrastructure below for automated packages and step-by-step instructions.',
    downloadManifest: 'Download Manifest XML',
    downloadWebBundle: 'Download Web Add-in Bundle (.ZIP)',
    downloadVstoPackage: 'Download VSTO Desktop Package (.ZIP)',
    pluginLogoRequired: 'Upload this organization’s reporting logo in Settings before downloading its Outlook add-in manifest.',
    vstoInstallerRequired: 'VSTO download is unavailable until Engineering supplies a signed installer built with this organization’s logo.',
    tabM365: 'Microsoft 365 (Cloud)',
    tabExchange: 'Exchange On-Premises',
    tabVsto: 'Classic Outlook / VSTO (GPO)',
    tenantBadge: 'Tenant Code',
    hostBadge: 'Plugin Host',
    endpointBadge: 'Target Endpoint',
    copyCommand: 'Copy Command',
    commandCopied: 'Copied to clipboard',
    m365Step1Title: '1. Centralized Deployment',
    m365Step1Desc: 'Log in to the Microsoft 365 Admin Center (admin.microsoft.com) -> Settings -> Integrated apps.',
    m365Step2Title: '2. Upload Custom App',
    m365Step2Desc: 'Click "Upload custom apps", choose "Upload manifest file (.xml) from device", and select the downloaded manifest XML.',
    m365Step3Title: '3. Assign Users & Deploy',
    m365Step3Desc: 'Select "Entire Organization" or target specific security groups, then finish the wizard. The add-in icon will appear in Outlook Web and Outlook Desktop within minutes.',
    exchangeStep1Title: '1. Launch Exchange Management Shell',
    exchangeStep1Desc: 'Open Exchange Management Shell as Administrator on your Exchange Server (Exchange 2013 SP1 / 2016 / 2019).',
    exchangeStep2Title: '2. Execute Deployment Script',
    exchangeStep2Desc: 'Extract the downloaded bundle and run deploy-exchange.ps1, or execute the following PowerShell command directly:',
    exchangeStep3Title: '3. Connectivity & Verification',
    exchangeStep3Desc: 'Ensure user workstations have outbound HTTPS (TCP 443) connectivity to your Rawam instance and plugin host.',
    vstoStep1Title: '1. Silent Workstation Install',
    vstoStep1Desc: 'Extract the VSTO package. For individual installation or testing, simply execute "install.bat" (no administrator privileges required).',
    vstoStep2Title: '2. Active Directory GPO Distribution',
    vstoStep2Desc: 'Deploy "RawamPhishingReporter.msi" silently via GPO Computer Software Installation or SCCM with arguments /quiet /qn.',
    vstoStep3Title: '3. Preconfigure Registry Keys',
    vstoStep3Desc: 'Import "gpo-deploy.reg" via Group Policy Preferences into HKCU\\Software\\Rawam\\PhishingReporter.',
  },

  categoryForm: {
    add: 'New category',
    edit: 'Edit category',
    enabled: 'This category is active',
    empty: 'No categories yet',
    deleteConfirm: 'Delete this category?',
    saved: 'Category saved',
    deleted: 'Category deleted',
    fail: {
      list: 'Could not load the categories',
      save: 'Could not save the category',
      delete: 'Could not delete the category',
      import: 'Could not import the categories file',
      export: 'Could not export the categories',
    },
  },

  domainForm: {
    add: 'New link',
    edit: 'Edit link',
    empty: 'No links yet',
    deleteConfirm: 'Delete this link?',
    saved: 'Domain saved',
    deleted: 'Domain deleted',
    fail: {
      list: 'Could not load the domains',
      save: 'Could not save the domain',
      delete: 'Could not delete the domain',
      import: 'Could not import the domains file',
      export: 'Could not export the domains',
    },
    imported: 'Links imported',
    importNote: 'An Excel file holding each link name and its address.',
  },

  /** The sender profiles a campaign sends from. */
  smtpForm: {
    add: 'New sender',
    edit: 'Edit sender',
    empty: 'No senders yet',
    deleteConfirm: 'Delete this sender?',
    saved: 'Sending profile saved',
    deleted: 'Sending profile deleted',
    tested: 'Connected to the sending server',
    // See the note in strings.ar.js.
    fail: {
      list: 'Could not load the sending profiles',
      save: 'Could not save the sending profile',
      delete: 'Could not delete the sending profile',
      test: 'Could not connect to the sending server',
      import: 'Could not import the sending profiles file',
      export: 'Could not export the sending profiles',
    },
    imported: 'Senders imported',
    importNote:
      'An Excel file with the columns: name, sender email, host, port, username, password, connection method, active, setting name, visible sender address, validate server certificate. Rows are matched by name, and an empty password keeps the stored one.',

    name: 'Sender name',
    nameHint: 'The name recipients see in the From field',
    settingName: 'Setting name',
    settingNameHint: 'An internal name to tell settings apart; recipients never see it',
    from: 'Sender email',
    fromHint: 'The address actually used to send (MAIL FROM)',
    visibleSenderAddress: 'Visible sender address',
    visibleSenderAddressHint: 'What recipients read — leave empty to use the sender email',

    host: 'Mail host',
    hostHint: 'The sending server, e.g. mail.domain.com',
    port: 'Port',
    portHint: 'Usually 587 or 465',
    username: 'Username',
    usernameHint: 'The mailbox used to sign in to the server',
    password: 'Password',
    passwordHint: 'The mailbox password',
    passwordKeptHint: 'Leave empty to keep the stored password',

    connectionMethod: 'Connection method',
    connectionMethodHint: 'The encryption used for the connection',
    validateCertificate: 'Validate server certificate',
    validateCertificateHint: 'Turn validation off for a server with a self-signed certificate',
    certificateDefault: 'Server default',
    certificateValidate: 'Validate the certificate',
    certificateSkip: 'Do not validate the certificate',
    active: 'This sender is active',
    activeHint: 'Only active senders are offered when a campaign picks one',

    test: 'Test sending',
    testAddress: 'Email address for testing',
  },

  /** The mailbox reports are read from. */
  imapForm: {
    add: 'New mailbox',
    edit: 'Edit mailbox',
    empty: 'No mailboxes yet',
    deleteConfirm: 'Delete this mailbox?',
    saved: 'Mailbox saved',
    deleted: 'Mailbox deleted',
    tested: 'Opened the mailbox',
    imported: 'Mailboxes imported',
    fail: {
      list: 'Could not load the mailboxes',
      save: 'Could not save the mailbox',
      delete: 'Could not delete the mailbox',
      test: 'Could not open the mailbox with these settings',
      import: 'Could not import the mailboxes file',
      export: 'Could not export the mailboxes',
    },

    host: 'Mail host',
    hostHint: 'The mailbox server, e.g. mail.domain.com',
    port: 'Port',
    portHint: 'Usually 993 encrypted, 143 otherwise',
    username: 'Username',
    password: 'Password',
    passwordHint: 'The mailbox password',
    passwordKeptHint: 'Leave empty to keep the stored password',
    folderName: 'Folder name',
    folderNameHint: 'The folder reports are read from, e.g. INBOX',
    connectionMethod: 'Connection method',
    connectionMethodHint: 'The encryption used for the connection',

    tls: 'TLS',
    tlsHint: 'Applied together with the chosen connection method',
    deleteEmails: 'Delete campaign emails once read',
    deleteEmailsHint: 'A reported message is removed from the mailbox after it is counted',
    active: 'This mailbox is active',
    activeHint: 'The listener service reads the active mailbox',
    singleActiveNote: 'Only one mailbox can be active — activating this one deactivates the rest.',

    test: 'Test connection',
  },

  tabs: {
    settings: 'Phishing settings',
    categories: 'Phishing Categories',
    smtp: 'Email SMTP Settings',
    imap: 'Email IMAP Settings',
    domains: 'Domains',
  },

  categories: {
    name: 'Arabic Name',
    nameEn: 'English Name',
    status: 'Active',
  },

  smtp: {
    senderName: 'Sender Name',
    host: 'Host',
    port: 'Port',
    from: 'Sender Email',
    username: 'Username',
    status: 'Active',
  },

  imap: {
    host: 'Host',
    port: 'Port',
    username: 'Username',
    folderName: 'Folder Name',
    connectionMethod: 'Connection Method',
    deleteEmails: 'Delete Campaigns Emails',
    status: 'Active',
    lastSync: 'Last read',
    neverSynced: 'Never read',
  },

  domains: {
    name: 'Name',
    url: 'URL',
  },

  deleteConfirm: 'Delete this entry?',

  deleted: 'Operation Completed Successfully',
}

/** Phishing reports — both levels. */
export const reportStrings = {
  qrVisited: 'QR destination opened',
  reportFail: {
    load: 'Could not load the phishing report',
    users: 'Could not load the recipients',
    export: 'Could not export the phishing report',
  },
  recipients: 'Recipients',
  allStatuses: 'All statuses',
  history: 'Failures across campaigns',
  historyValue: (failed, sent) => `${failed} / ${sent} (${sent ? Math.round(failed / sent * 1000) / 10 : 0}%)`,
  otherFailures: (count) => `Submitted data in ${count} other campaigns.`,
  historyHint: 'Distinct campaigns with submitted data out of campaigns sent, including this campaign. Repeated submissions count once per campaign; scheduled campaigns are excluded.',
  title: 'Phishing reports',
  subtitle: 'What the targets of each campaign did',
  funnel: 'Funnel',
  share: 'Shares',
  shareHint: 'Of everyone the campaign reached',
  shareOf: (count, total) => `${count} of ${total}`,
  byCampaign: 'By campaign',
  trend: 'Clicks and reports per campaign',
  trendHint: 'Who clicked and who reported, of everyone each campaign reached, in the order the campaigns started',
  backToAll: 'All campaigns',
  exportExcel: 'Export to Excel',
  actionFailed: 'The operation could not be completed',
  noCampaigns: 'No campaigns',
  noUsers: 'This campaign reached nobody',
  refresh: 'Refresh',
  details: 'Details',
  userDetails: 'Recipient details',
  timeline: 'Event timeline',
  noEvents: 'No recorded events',
  classification: {
    suspectedAutomated: 'Suspected automated',
    confirmedHuman: 'Confirmed human',
    suppressed: 'Blocked by an exclusion rule',
    afterWindow: 'After the campaign ended',
    evidence: 'Kept for audit only; not counted in the results.',
    reasons: {
      noAgent: 'No user agent',
      scanner: 'Known scanner agent',
      seconds: 'seconds after delivery',
      rule: 'Rule',
      beacon: 'Interaction in the browser',
    },
  },

  ipAddress: 'IP address',
  userAgent: 'User agent',
  forwardedFor: 'Forwarded for',
  metadata: 'Metadata',
  submittedFields: 'Submitted fields',

  /* Said plainly because the field names mislead. */
  countingNote:
    'Activity counts reflect recorded events. A recipient can click and later report the same message. Reporting does not remove earlier clicks or data submissions.',
  notRecorded: 'Not recorded',

  stages: {
    sent: 'Email Sent',
    opened: 'Email Opened',
    clicked: 'Link Clicked',
    submitted: 'Data Submitted',
    reported: 'Reported',
  },

  columns: {
    campaign: 'Campaign',
    startedOn: 'Start date',
    status: 'Status',
    user: 'Target',
    email: 'Email',
    department: 'Department',
    phished: 'Times data submitted',
    reportedOn: 'Reported on',
    details: 'Details',
  },

  /** PhishingUserStatus — the scale the recipient rows arrive on, -1..4. */
  states: {
    '-1': 'Scheduled',
    [PHISHING_USER_STATUS.SENT]: 'Email Sent',
    [PHISHING_USER_STATUS.EMAIL_OPENED]: 'Email Opened',
    [PHISHING_USER_STATUS.LINK_CLICKED]: 'Link Clicked',
    [PHISHING_USER_STATUS.DATA_SUBMITTED]: 'Data Submitted',
    [PHISHING_USER_STATUS.USER_REPORTED]: 'Reported',
  },
}
